import "./Footer.scss";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      © {currentYear} CODACO ELECTRONIC s.r.o. | Vytvořil Vladan Dwornik
    </footer>
  );
}
